import { selectProtectedUserRole } from "@/store/slices/user";

import { useAppSelector } from "./redux";

export const useProtectedUserRoleSelector = () =>
    useAppSelector(selectProtectedUserRole);
